export default function dropOrientation() {
  if (window.innerWidth > 1023) {
    $('#main-navigation>ul>li>a').mouseenter(function () {
      var windowWidth = $(window).width();
      var navDropPositionLeft = $(this).offset().left;
      var navDropElementWidth = $(this).siblings('.nav-drop-holder').outerWidth(true);
      var offset = windowWidth - (navDropPositionLeft + navDropElementWidth);

      if (offset < 0) {
        $(this).siblings('.nav-drop-holder').css({
          left: 'auto',
          right: '0'
        });
      } else {
        $(this).siblings('.nav-drop-holder').css({
          left: '0',
          right: 'auto'
        });
      }
    });
  } else {
    $('.nav-drop').removeAttr('style');
  }
}